import React, { useState } from "react";
import Grid from '@mui/material/Grid';
import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from "@mui/material";
import TextMicroOverview from "./TextMicroOverview"
import CustomDialog from '../../../../components/Dialog/DiaComp';


export default function StatusInfo() {

        const [open, setOpen] = useState(false);
        const handleOpen = () => {setOpen(true);};
        const handleClose = () => {setOpen(false);};

return(
<>      

        <Grid container sx={{ justifyContent:'center'}}>
                <IconButton onClick={handleOpen} size="small" >
                        <InfoIcon sx={{color: 'common.white', fontSize: '230%', '&:hover': { color: 'background.bluelight'}, }}/>
                </IconButton>   
        </Grid>
    
        <CustomDialog open={open} onClose={handleClose}

                title="Microbiome Overview"
                content={ <TextMicroOverview /> }

        />
</>
)}